export const common = {
  siteName: "Discover UB",
  tagline: "What to Do in Ulaanbaatar, Right Now",
  searchPlaceholder: "Search food, vibe, or place in Ulaanbaatar…",
  language: "English",
  switchLanguage: "Монгол",
  
  nav: {
    home: "Home",
    mapView: "Map View"
  },
  
  bottomNav: {
    home: "Home",
    map: "Map",
    saved: "Saved",
    profile: "Profile",
    comingSoon: "Coming soon"
  },
  
  moods: {
    chill: "Chill",
    eat: "Eat",
    party: "Party",
    romantic: "Romantic",
    explore: "Explore",
    recover: "Recover"
  },
  
  categories: {
    all: "All",
    eat: "Restaurants",
    party: "Nightlife",
    pub: "Pubs",
    explore: "Attractions",
    romantic: "Date Spots",
    unique: "Unique Places",
    spa: "Spa & Massage",
    massage: "Massage Parlors",
    coffee: "Coffee Shops",
    shopping: "Shopping"
  },
  
  filters: {
    day: "Day",
    night: "Night",
    openNow: "Open now",
    budget: "Budget",
    distance: "Near me"
  },
  
  placeCard: {
    verified: "Verified",
    open: "Open",
    closed: "Closed",
    hours: "Hours",
    contact: "Contact",
    directions: "Directions",
    views: "views"
  },

  placeDetail: {
    about: "About",
    insiderTip: "Insider Tip",
    address: "Address",
    amenities: "Amenities",
    bestTime: "Best Time to Visit",
    daytime: "Daytime",
    nighttime: "Nighttime",
    share: "Share",
    save: "Save"
  },
  
  trending: {
    title: "Trending Now",
    busyNow: "Busy now",
    newThisWeek: "New this week",
    localsPicks: "Locals' picks"
  },
  
  results: {
    showing: "Showing",
    places: "places"
  }
};

export default common;